import {GenericService, ResultType} from '@/shared/xhttp';
import {Tva} from '@/models';

export class TvaService extends GenericService<Tva> {

	public getAll(): Promise<ResultType<Tva>> {
		return this.getC('', 200, 0, 'id');
	}

}